import load from '#core/load';
import { spotlight_hero } from '#core/pattern-params';


// Cycles the words inside the hero headline's `{word}` slot. The words are a
// vertical stack clipped to one line; advancing means translating the stack up
// by a line, so the outgoing word rides out of the top as the incoming one
// arrives from below. The transition itself lives in the SCSS — this only
// moves the index and marks which word is the live one.

const module_name = 'spotlight-hero';

const rotator_$ = '[data-rotator]';
const list_$ = '[data-rotator-list]';

const current_attr = 'data-rotator-current';
const index_prop = '--rotator-index';

const interval = parseInt(spotlight_hero.rotation_interval, 10);


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran(module_name)) return false;

		load.content(() => {
			// Motion for its own sake: with the rotation off the headline still
			// reads correctly, because word one is the authored fallback.
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

			document.querySelectorAll(rotator_$).forEach(start);
		});
	},

};

export default module;
module.init();


/**
 * Start one rotator cycling
 * @param {Element} $rotator
 * @return {boolean}
 */
function start($rotator) {
	const $list = $rotator.querySelector(list_$);
	if (!$list) return false;

	const $words = Array.from($list.children);
	if ($words.length < 2) return false;

	// The stack only travels downward, so getting from the last word back to
	// the first needs a copy of the first sitting after it. The cycle lands on
	// that copy, then snaps back to the real one with the transition
	// suppressed — which reads as continuous rather than as a rewind.
	const $loop_word = $words[0].cloneNode(true);
	$loop_word.removeAttribute(current_attr);
	$loop_word.setAttribute('aria-hidden', 'true');
	$list.appendChild($loop_word);

	const $all = $words.concat([$loop_word]);
	let index = 0;

	setInterval(() => {
		index += 1;

		$all.forEach(($word, i) => {
			$word.toggleAttribute(current_attr, i === index);
		});
		$list.style.setProperty(index_prop, index);

		if (index < $words.length) return;

		// Landed on the copy. Once it has finished arriving, swap to the real
		// first word in place: same pixels, so nothing is seen to move.
		//
		// The guard is the whole of this. transitionend bubbles, and the words
		// are children of the list -- each one fading on its own, deliberately
		// quicker than the roll. So the first transitionend to reach the list
		// on a wrap step is a word's opacity finishing, not the list's own
		// translate, and an unguarded `once` listener fired on it: the snap
		// ran mid-roll, killed the transition and reset the index while the
		// stack was still travelling. That is the visible hiccup, and it
		// arrived on the wrap -- after cycling once through the words.
		const on_translate_end = (event) => {
			if (event.target !== $list) return;

			$list.removeEventListener('transitionend', on_translate_end);

			$list.setAttribute('data-rotator-snapping', 'true');
			index = 0;
			$list.style.setProperty(index_prop, index);
			$all.forEach(($word, i) => {
				$word.toggleAttribute(current_attr, i === index);
			});

			// Read back a layout property so the reset is committed before the
			// transition is allowed again, otherwise the two changes coalesce
			// into one frame and the snap animates after all.
			void $list.offsetHeight;
			$list.removeAttribute('data-rotator-snapping');
		};

		$list.addEventListener('transitionend', on_translate_end);
	}, interval);

	return true;
}
